import React from "react";
import { useRefData } from "../context/RefDataContext";
import { colorSwatch } from "../lib/vehicleColors";

const SIZES = { sm: "h-3.5 w-3.5", md: "h-4 w-4", lg: "h-5 w-5" };

/**
 * The vehicle's colour as a dot; the name is in the tooltip and for screen
 * readers, and shown next to it only with `showName`. Pass `color`, or
 * `vehicleId` to read it from the fleet list. An unrecognised old value gets a
 * striped dot; no colour shows nothing.
 */
export default function VehicleColor({ color, vehicleId, showName = false, size = "md", className = "" }) {
  const refData = useRefData();
  const name = color ?? refData?.vehicles?.find((v) => v.id === vehicleId)?.color;
  if (!name || !String(name).trim()) return null;
  const swatch = colorSwatch(name);
  return (
    <span className={`inline-flex min-w-0 items-center gap-2 text-sm font-normal ${className}`} title={`Colore: ${name}`} data-testid="vehicle-color">
      <span aria-hidden="true" className={`${SIZES[size] || SIZES.md} shrink-0 rounded-full border-2 border-foreground/25 shadow-sm`} data-swatch={swatch || "unknown"}
        style={swatch ? { backgroundColor: swatch } : { backgroundImage: "repeating-linear-gradient(45deg, transparent 0 3px, hsl(var(--muted-foreground) / 0.6) 3px 5px)" }} />
      {showName ? <span className="truncate">{name}</span> : <span className="sr-only">Colore: {name}</span>}
    </span>
  );
}
